<template>
  <div class="setting-main-container" v-if="getBusinessPermission || userType=='super_admin' ">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.business_nature.business_nature') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-12 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.business_name') }}</label><span class="text-danger"> * </span>
            <p v-if="business && business.name !=null ">{{ business.name }}</p>
          </div>
          <div class="col-md-12 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.address') }}</label><span class="text-danger"> * </span>

              <p v-if="business && business.address !=null ">{{ business.address }}</p>
          </div>
          <div class="col-md-12 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.business_phone') }}</label><span class="text-danger"> * </span>
            <p v-if="business && business.phone !=null ">{{ business.phone }}</p>
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.sales_tax_num') }}</label>
            <p v-if="business && business.sale_tax !=null ">{{ business.sale_tax }}</p>
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.email') }}</label>
            <p v-if="business && business.email !=null ">{{ business.email }}</p>
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.importing_registration') }}</label>
            <p v-if="business && business.importing_registration !=null ">{{ business.importing_registration }}</p>
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.exporting_registration') }}</label>
            <p v-if="business && business.exporting_registration !=null ">{{ business.exporting_registration }}</p>
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.date_establishment') }}</label><span class="text-danger"> * </span>
            <p v-if="business && business.date_establishment !=null ">{{ this.business.date_establishment }}</p>
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.date_opening_ac') }}</label><span class="text-danger"> * </span>
            <p v-if="business && business.date_openingAc !=null ">{{ this.business.date_openingAc }}</p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
const { required, numeric,maxLength, alpha,minLength,email } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      userType:null,
    }
  },
  computed: {
    ...mapGetters('stakeholder', [
      'stakeholders'
    ]),
     ...mapGetters('business', [
      'business',
      'getBusinessPermission',
    ]),

  },
  watch: {},
  validations: {},
  created() {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    if(localStorage.getItem('role')=='super_admin' && this.business==null){
      this.getBusinessData();
    }
    this.checkBusinessPermission();
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('business', [
      'falseBusinessPermission',
      'BusinessPermission',
      'fetchBusinessByUser'
    ]),
    checkBusinessPermission(){
      this.BusinessPermission(this.$route.params.id)
    },
    async getBusinessData(){
      let formData = {
        user_id : this.$route.params.id,
      }
      let  response = await this.fetchBusinessByUser(formData)
    }
  }
}
</script>
